import { Breakpoint, Button, CheckboxField, Color, FontWeight, Markdown, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 95vh;

  @media ${Breakpoint.Tablet} {
    flex-direction: row;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-top: 44px;

  @media ${Breakpoint.Tablet} {
    justify-content: flex-start;
    flex: 1;
  }
`;

export const StyledSVG = styled.svg`
  color: ${Color.Brand300};

  @media ${Breakpoint.Tablet} {
    width: 90%;
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  padding: 40px 16px;

  @media ${Breakpoint.Tablet} {
    flex: 1;
    align-items: flex-start;
    padding: 48px 112px 48px 70px;
    gap: 16px;
  }
`;

export const Title = styled(Typography)`
  margin-bottom: 24px;
  font-weight: ${FontWeight.Bold};

  @media ${Breakpoint.Tablet} {
    margin-bottom: 0
  }
`;

export const FormFieldsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InfoBoxContent = styled(Markdown)`
  font-size: 12px;
  line-height: 18px;
  flex-direction: column;

  p + p {
    margin-top: 15px;
  }

  p {
    padding-left: 40px;
  }
`;

export const Disclaimer = styled(Typography)`
  color: ${Color.Red900};
`;

export const AgreementsContainer = styled.div`
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media ${Breakpoint.Tablet} {
    padding: 16px 0;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${Color.Gray300};
`;

export const StyledCheckboxField = styled(CheckboxField)`
  .astrix {
    color: ${Color.Red900};
  }
`;

export const StyledButton = styled(Button)`
  margin: 28px 0;
`;
